var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({style:(_vm.containerStyle)},_vm.$listeners),[_c('IconSecondary',{attrs:{"display":"block","content":_vm.content,"fontSize":_vm.fontSize}}),_c('div',{style:(_vm.slotContainerStyle)},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }